import { makeStyles } from '@material-ui/core/styles';
// import theme from '../../theme/booking-theme';

const useStyles = makeStyles(() => ({
  MuiDialogContentRoot: {
    padding: '0 !important',
  },
}));

export default useStyles;
